import { AppContext } from '@farris/devkit';
import { HtmlEditorComponent } from '@farris/ui-html-editor';
import { AbstractEndEdit } from './abstract_end_edit';
import { Directive } from '@angular/core';
@Directive({
  selector: '[html-editor-end-edit]'
})
class HtmlEditorEndEditDirective extends AbstractEndEdit {
  constructor(protected appContext: AppContext, private editor: HtmlEditorComponent) {
    super(appContext);
  }
  public endEdit(message: any) {
    if (this.editor && typeof this.editor.endEdit === 'function') {
      this.editor.endEdit();
    }
  }

}
export { HtmlEditorEndEditDirective };
